import { useMutation, useQueryClient } from 'react-query';

import { updateTrapActivationSignalComment as update } from 'api/traps/MultiCatchTrap/updateTrapActivationSignalComment';

interface UpdateCommentParams {
  signalId: number;
  type: string;
  comment?: string;
  removeComment?: boolean;
}

const useUpdateTrapActivationSignalComment = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: updateComment,
    isLoading,
  } = useMutation(
    (params: UpdateCommentParams) => update(params.signalId, params.type, params.comment, params.removeComment),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('GetTrapActivationHistory');
      },
    },
  );

  return {
    isSuccess,
    updateComment,
    isLoading,
  };
};

export default useUpdateTrapActivationSignalComment;
